import Vue from "vue"
import Vuex from "vuex"

import user from './module/user'
import memberSign from './module/memberSign'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        //
    },
    mutations: {
        //
    },
    actions: {
        //
    },
    modules: {
        user,
        memberSign
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js